import { useState, useEffect } from 'react'
import { useProgress } from '@react-three/drei'
import { useLenis } from './hooks'
import Scene from './Scene'
import Overlay from './components/Overlay'

import './styles.css'

// Minimalist Loader
function CustomLoader() {
  const { progress, active } = useProgress()
  const [displayProgress, setDisplayProgress] = useState(0)
  const [isVisible, setIsVisible] = useState(true)
  const [isFading, setIsFading] = useState(false)

  useEffect(() => {
    const target = Math.min(progress, 99)
    const timer = setInterval(() => {
      setDisplayProgress(prev => prev < target ? Math.min(prev + 1, target) : prev)
    }, 20)
    return () => clearInterval(timer)
  }, [progress])

  useEffect(() => {
    if (!active && displayProgress >= 99) {
      setTimeout(() => {
        setDisplayProgress(100)
        setTimeout(() => {
          setIsFading(true)
          setTimeout(() => setIsVisible(false), 500)
        }, 500)
      }, 1000)
    }
  }, [active, displayProgress])

  if (!isVisible) return null

  return (
    <div className={`custom-loader ${isFading ? 'fade-out' : ''}`}>
      <div className="loader-content">
        <span className="loader-percent">{Math.round(displayProgress)}%</span>
        <div className="loader-bar">
          <div className="loader-bar-fill" style={{ width: `${displayProgress}%` }} />
        </div>
      </div>
    </div>
  )
}

export default function App() {
  useLenis()

  return (
    <>
      <CustomLoader />
      <Scene />
      <Overlay />
    </>
  )
}
